var $f54dc67957f79322$exports = {};
$f54dc67957f79322$exports = {
    "alert": `Br\u{12B}din\u{101}jums`,
    "dismiss": `Ner\u{101}d\u{12B}t`
};


export {$f54dc67957f79322$exports as default};
//# sourceMappingURL=lv-LV.mjs.map
